import { useParams } from 'react-router-dom';

import { useMyPermissions } from '@/api/getMyPermissions';
import {
  holdsPermissions,
  type PermissionCheckOptions,
} from '@/models/permission';

// Re-exported from the model layer, where the route gate reads them too.
export type {
  PermissionCheckOptions,
  PermissionScope,
} from '@/models/permission';

/**
 * Whether the signed-in user holds the requested permissions in the current scope.
 * The route counterpart is `requirePermissions` (src/app/requirePermissions.ts) —
 * both evaluate through `holdsPermissions`.
 *
 * Fails closed: false while the Grants are loading and on error.
 */
export const usePermissionCheck = (check: PermissionCheckOptions): boolean => {
  // ponytail: useParams, not useSandboxContext — the latter throws outside
  // /:gameCode/:sandboxCode, and gates are needed above it too.
  const params = useParams<{ gameCode?: string; sandboxCode?: string }>();
  const { data } = useMyPermissions();

  return data?.roles ? holdsPermissions(data.roles, check, params) : false;
};
